import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import {
  type FolderFilesOrderBy,
  type FolderFilesOrderDirection,
} from '@/routes/_staff/storage-files/-shared/-query/type';

const ORDER_BY_VALUES = [
  'name',
  'owner',
  'updatedAt',
] as const satisfies readonly FolderFilesOrderBy[];

const ORDER_DIRECTION_VALUES = [
  'asc',
  'desc',
] as const satisfies readonly FolderFilesOrderDirection[];

const SearchSchema = z.object({
  pageIndex: z.number().optional().default(0),
  pageSize: z.number().optional().default(100),
  freeText: z.string().optional().default(''),
  orderBy: z.enum(ORDER_BY_VALUES).optional(),
  orderDirection: z.enum(ORDER_DIRECTION_VALUES).optional(),
});

export const Route = createFileRoute(
  '/_staff/storage-files/folders/$id/_$id/files/',
)({
  validateSearch: zodValidator(SearchSchema),
});
